var ɵ0 = function (seconds) { return "a few seconds ago"; }, ɵ1 = function (seconds) { return "in a few seconds"; }, ɵ2 = function (minutes) { return minutes + " minutes ago"; }, ɵ3 = function (minutes) { return "in " + minutes + " minutes"; }, ɵ4 = function (hours) { return hours + " hours ago"; }, ɵ5 = function (hours) { return "in " + hours + " hours"; }, ɵ6 = function (days) { return days + " days ago"; }, ɵ7 = function (days) { return "in " + days + " days"; }, ɵ8 = function (months) { return months + " months ago"; }, ɵ9 = function (months) { return "in " + months + " months"; }, ɵ10 = function (years) { return years + " years ago"; }, ɵ11 = function (years) { return "in " + years + " years"; };
var defaultLocale = {
    secondsAgo: ɵ0,
    inSeconds: ɵ1,
    oneMinuteAgo: '1 minute ago',
    inOneMinute: 'in 1 minute',
    minutesAgo: ɵ2,
    inMinutes: ɵ3,
    oneHourAgo: '1 hour ago',
    inOneHour: 'in 1 hour',
    hoursAgo: ɵ4,
    inHours: ɵ5,
    oneDayAgo: '1 day ago',
    inOneDay: 'in 1 day',
    daysAgo: ɵ6,
    inDays: ɵ7,
    oneMonthAgo: '1 month ago',
    inOneMonth: 'in 1 month',
    monthsAgo: ɵ8,
    inMonths: ɵ9,
    oneYearAgo: '1 year ago',
    inOneYear: 'in 1 year',
    yearsAgo: ɵ10,
    inYears: ɵ11
};
/**
 * @public
 */
// tslint:disable-next-line:cognitive-complexity
export function getRelativeTime(time, locale, forceUpdateFlag) {
    if (!locale) {
        locale = defaultLocale;
    }
    var value = typeof time !== 'number' ? time.valueOf() : time;
    var offset = value - Date.now();
    var seconds = Math.round(Math.abs(offset) / 1000.0);
    if (seconds < 45) {
        return offset < 0 ? locale.secondsAgo(seconds) : locale.inSeconds(seconds);
    }
    var minutes = Math.round(seconds / 60);
    if (minutes <= 1) {
        return offset < 0 ? locale.oneMinuteAgo : locale.inOneMinute;
    }
    if (minutes < 60) {
        return offset < 0 ? locale.minutesAgo(minutes) : locale.inMinutes(minutes);
    }
    var hours = Math.round(minutes / 60);
    if (hours <= 1) {
        return offset < 0 ? locale.oneHourAgo : locale.inOneHour;
    }
    if (hours < 24) {
        return offset < 0 ? locale.hoursAgo(hours) : locale.inHours(hours);
    }
    var days = Math.round(hours / 24);
    if (days <= 1) {
        return offset < 0 ? locale.oneDayAgo : locale.inOneDay;
    }
    if (days < 30) {
        return offset < 0 ? locale.daysAgo(days) : locale.inDays(days);
    }
    var months = Math.round(days / 30);
    if (months <= 1) {
        return offset < 0 ? locale.oneMonthAgo : locale.inOneMonth;
    }
    if (months < 12) {
        return offset < 0 ? locale.monthsAgo(months) : locale.inMonths(months);
    }
    var years = Math.round(days / 365);
    if (years <= 1) {
        return offset < 0 ? locale.oneYearAgo : locale.inOneYear;
    }
    return offset < 0 ? locale.yearsAgo(years) : locale.inYears(years);
}
/**
 * @public
 */
export function format(time) {
    var date = typeof time !== 'number' ? time : new Date(time);
    return date.toLocaleString();
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };



//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-component/dist/index.js
// module id = null
// module chunks = 